import SocialAttendanceTypeRepository from '@/shared/http/repositories/socialProject/social-attendance-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import SocialAttendanceType from '@/shared/models/socialAttendanceType'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EditarTipoDeAtendimentoSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Tipo de Atendimento Social',
    socialAttendanceType: new SocialAttendanceType(),
    isNew: false
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipos de Atendimento Social',
            href: this.$router.resolve({ name: 'SocialAttendanceType' }).href
          },
          {
            text: 'Editar Tipo de Atendimento Social',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      SocialAttendanceTypeRepository.GetById(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.socialAttendanceType = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tipo de atendimento social', 'ERRO')
        })
    },

    update(socialAttendanceType) {
      loading.push()
      SocialAttendanceTypeRepository.Update(socialAttendanceType)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Tipo de Atendimento Social editado com sucesso', 'EDITAR TIPO DE ATENDIMENTO SOCIAL')
          Promise.resolve()
          return this.$router.replace({ name: 'SocialAttendanceType' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar tipo de atendimento social', 'ERRO')
        })
    }
  }
}
